import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How much does it cost to work with you?",
    a: "Our initial consultation and rescue plan are 100% free. For surplus fund recovery we only earn a success fee after we recover money for you — if we recover nothing, you owe nothing. For fast-cash sales, our buyers cover all closing costs on their side.",
  },
  {
    q: "Can you really stop a foreclosure that's already scheduled?",
    a: "In most cases, yes — provided there is enough time. We've halted auctions within 72 hours via reinstatement, forbearance, Chapter 13 referrals, short sale negotiation, or last-minute cash purchase. The earlier you call, the more options you have.",
  },
  {
    q: "What are surplus funds (or excess proceeds)?",
    a: "When your home is sold at foreclosure auction for more than what you owed on the mortgage (plus fees), the extra amount belongs to you, the former homeowner. Many states hold these funds in court for a limited time before they're forfeited to the state. We help you claim them before that happens.",
  },
  {
    q: "How fast can you make a cash offer on my house?",
    a: "We can return a preliminary offer within 24 hours of receiving your details. Closings typically happen in 7–21 days, depending on title work in your state.",
  },
  {
    q: "Do you buy houses in any condition?",
    a: "Yes. Our investor network buys homes with foundation issues, fire damage, squatters, open code violations, tenants in place, hoarder conditions, and more. No repairs, no cleanouts required.",
  },
  {
    q: "Is my information kept confidential?",
    a: "Always. We never sell your data, we never contact your neighbors, and we only speak with third parties (your lender, trustee, county clerk) with your written permission.",
  },
  {
    q: "Do you operate in my state?",
    a: "Yes. Clear Path Home Relief Services serves homeowners in all 50 U.S. states. Our advocates are trained in state-specific foreclosure timelines and surplus funds laws.",
  },
  {
    q: "What if I just want advice and not a service?",
    a: "That's welcome too. Our advocates will walk you through your options at no cost — even if the best answer for you is to handle it yourself or work with a local attorney.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-32 bg-[#FAF9F6]"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="mb-12 text-center">
          <div className="mb-4">
            <span className="gold-rule" />
            <span className="text-xs uppercase tracking-[0.24em] text-[#2C5545] font-medium">
              Frequently Asked
            </span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0B1B3D] leading-tight">
            Everything homeowners ask us first.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-[#E5E3DB]"
            >
              <AccordionTrigger className="font-display text-lg sm:text-xl text-[#0B1B3D] text-left hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#64748B] text-[15px] leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
